var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 2.46154,
    transform: "matrix(-1 0 0 1 22 0)",
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3611 6.7222H12.0694L11.8784 6.37845C11.8021 6.22567 11.6493 6.11108 11.4774 6.11108H9.28122C9.10935 6.11108 8.95657 6.22567 8.88018 6.37845L8.70831 6.7222H6.41664C6.24476 6.7222 6.11108 6.87497 6.11108 7.02775V7.63886C6.11108 7.81074 6.24476 7.94442 6.41664 7.94442H14.3611C14.5139 7.94442 14.6666 7.81074 14.6666 7.63886V7.02775C14.6666 6.87497 14.5139 6.7222 14.3611 6.7222ZM7.12324 15.0295C7.14233 15.526 7.54338 15.8889 8.0399 15.8889H12.7187C13.2153 15.8889 13.6163 15.526 13.6354 15.0295L14.0555 8.55553H6.7222L7.12324 15.0295Z",
    fill: "#343A40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonTrash);
export default __webpack_public_path__ + "static/media/ButtonTrash.9a306d5b47dacd3e63f9365c1e66cf71.svg";
export { ForwardRef as ReactComponent };